import { createReducer, on } from '@ngrx/store'
import {
   retriveProjectFinalProposals,
   retriveProjectFinalProposalsFailure,
   retriveProjectFinalProposalsSuccess,
} from '../feature-project-detail/feature-pd.actions'
import * as FeatureMYPActions from './feature-myp.actions'
import { FeatureMYPState } from './feature-myp.state'
import { MPOrderOptionKeyEnum } from '../../../features/feature-manage-projects/models/mp-order-option.interface'

export const initialState: FeatureMYPState = {
   searchResult: undefined,
   isLoading: false,
   isSearchDone: false,
   searchRequest: undefined,
}

export const featureMYPReducer = createReducer(
   initialState,
   on(FeatureMYPActions.searchYourProjects, (state) => ({ ...state, searchResult: undefined, isLoading: true, isSearchDone: true })),
   on(FeatureMYPActions.searchYourProjectsSuccess, (state, action) => ({ ...state, searchResult: action.result })),
   on(FeatureMYPActions.searchYourProjectsSuccess, FeatureMYPActions.searchYourProjectsFailure, (state) => ({ ...state, isLoading: false })),

   on(FeatureMYPActions.setActualOrderYourProjects, (state, action) => ({
      ...state,
      searchRequest: {
         ...state.searchRequest,
         paging: {
            ...state.searchRequest?.paging,
            field: action.order,
            order: action.order ? (action.order == MPOrderOptionKeyEnum.LAST_MODIFIED ? 'DESC' : 'ASC') : 'ASC',
            pageNumber: 0,
         },
      },
   })),
   on(FeatureMYPActions.setActualPageYourProjects, (state, action) => ({
      ...state,
      searchRequest: { ...state.searchRequest, paging: { ...state.searchRequest?.paging, pageNumber: action.page } },
   })),
   on(FeatureMYPActions.setSearchRequestYourProjects, (state, action) => ({
      ...state,
      searchRequest: action.request,
   })),
   on(FeatureMYPActions.setItemForPageYourProjects, (state, action) => ({
      ...state,
      searchRequest: { ...state.searchRequest, paging: { ...state.searchRequest?.paging, pageSize: action.itemForPage } },
   })),
   on(FeatureMYPActions.initManageYourProjectSearch, (state) => ({
      ...state,
      searchResult: undefined,
      isLoading: false,
      isSearchDone: false,
      searchRequest: undefined,
   })),
   on(retriveProjectFinalProposals, (state, action) => ({
      ...state,
      searchResult: {
         ...state.searchResult,
         results: [
            ...(state.searchResult?.results?.map((item) => {
               let newItem = { ...item }
               if (item.id == action.id) {
                  newItem.isLoadingFinalProposals = true
               }
               return newItem
            }) ?? []),
         ],
      },
   })),
   on(retriveProjectFinalProposalsSuccess, retriveProjectFinalProposalsFailure, (state) => ({
      ...state,
      searchResult: {
         ...state.searchResult,
         results: [
            ...(state.searchResult?.results?.map((item) => {
               let newItem = { ...item }
               if (item.isLoadingFinalProposals) {
                  newItem.isLoadingFinalProposals = false
               }
               return newItem
            }) ?? []),
         ],
      },
   })),
   on(FeatureMYPActions.exportExcelResults, (state) => ({
      ...state,
      isDownloadLoading: true,
   })),
   on(FeatureMYPActions.exportExcelResultsSuccess, FeatureMYPActions.exportExcelResultsFailure, (state) => ({
      ...state,
      isDownloadLoading: false,
   }))
)
